import { SeverityEnum } from '../../enums/alert/severity.enum';
import { AlertType } from '../../enums/alert/type.enum';
import { AlertWrapper } from './smartphoto-alert-wrapper';
import { AlertCategory } from '../../enums/alert/alert-category.enum';
export class SmartphotoAlerts {
    alerts = [];
    originalSmartphoto;
    smartphoto;
    damages = [];
    frauds = [];
    quality = [];
    vlc = [];
    rt = [];
    constructor(smartphoto) {
        this.originalSmartphoto = smartphoto;
        this.reset();
    }
    static create(smartphoto) {
        return new this(smartphoto);
    }
    getActive(category) {
        return this.alerts
            .filter(({ category: alertCategory, value }) => alertCategory === category && value)
            .map(({ name, severity }) => ({ type: name, severity }));
    }
    addDamagesAlerts(damageSummary) {
        const securityThreatPartsFound = damageSummary.some((damage) => damage.mainDetection.damages.at(0)?.safety_threat);
        this.alerts = [
            ...this.alerts,
            new AlertWrapper(AlertType.securityThreatParts, AlertCategory.Damages, SeverityEnum.high, { fraud: securityThreatPartsFound }, 'fraud')
        ];
    }
    addFraudsAlerts(frauds, GPSPermissionsAccepted = true) {
        const { screenDetection, plateDetection, uniqueVehicle, gpsLocation, vinDetection, odometer } = frauds ?? {};
        const fraudAlerts = [
            {
                name: AlertType.screenDetection,
                target: screenDetection
            },
            {
                name: AlertType.plateComparison,
                target: plateDetection?.plateComparison
            },
            {
                name: AlertType.plateCaseCheck,
                target: plateDetection?.caseCheck
            },
            {
                name: AlertType.missingPlate,
                target: plateDetection?.missingPlate
            },
            {
                name: AlertType.uniqueVehicle,
                target: uniqueVehicle
            },
            {
                name: AlertType.gpsLocation,
                target: gpsLocation
            },
            {
                name: AlertType.missingVin,
                target: vinDetection?.missingVin
            },
            {
                name: AlertType.undecodeableVin,
                target: vinDetection?.undecodableVin
            },
            {
                name: AlertType.vinCaseCheck,
                target: vinDetection?.caseCheck
            },
            {
                name: AlertType.wrongVin,
                target: vinDetection?.wrongVin
            },
            {
                name: AlertType.missingOdometer,
                target: odometer?.missingOdometer
            },
            {
                name: AlertType.GPSPermissionsAccepted,
                target: { fraud: !GPSPermissionsAccepted }
            }
        ];
        fraudAlerts.forEach((fraudAlert) => this.alerts.push(new AlertWrapper(fraudAlert.name, AlertCategory.Frauds, SeverityEnum.high, fraudAlert.target ?? {}, 'fraud')));
    }
    addQualityAlerts(qualitySummary, notSupportWebGL = false) {
        const { qualityDetection, vehicleDetection, orientationDetection } = qualitySummary ?? {};
        const qualityAlerts = [
            {
                name: AlertType.qualityDetection,
                target: qualityDetection
            },
            {
                name: AlertType.vehicleDetection,
                target: vehicleDetection
            },
            {
                name: AlertType.orientationDetection,
                target: orientationDetection
            },
            {
                name: AlertType.notSupportWebGL,
                target: { issue: notSupportWebGL }
            }
        ];
        qualityAlerts.forEach((qualityAlert) => this.alerts.push(new AlertWrapper(qualityAlert.name, AlertCategory.Quality, SeverityEnum.high, qualityAlert.target ?? {}, 'issue')));
    }
    addRTAlert() {
        const { alerts: { rt } } = this.smartphoto;
        this.alerts.push(new AlertWrapper(AlertType.realTime, AlertCategory.RT, SeverityEnum.medium, { issue: rt }, 'issue'));
        this.update();
    }
    addVLCAlerts(vlcWarnings) {
        this.alerts = [
            ...this.alerts.filter((alert) => alert.name !== AlertType.vlcMileage && alert.name !== AlertType.vlcPreviousDamage),
            new AlertWrapper(AlertType.vlcMileage, AlertCategory.VLC, SeverityEnum.high, { issue: vlcWarnings.odometer }, 'issue'),
            new AlertWrapper(AlertType.vlcPreviousDamage, AlertCategory.VLC, SeverityEnum.high, { issue: vlcWarnings.damages }, 'issue')
        ];
        this.update();
    }
    totalAlertsOfDamage() {
        return this.damages.length;
    }
    totalAlertsOfFraud() {
        return this.frauds.length;
    }
    totalAlertsOfQuality() {
        return this.quality.length;
    }
    totalAlertsOfVLC() {
        return this.vlc.length;
    }
    totalAlertsOfRT() {
        return this.rt.length;
    }
    totalAlerts() {
        return (this.totalAlertsOfDamage() +
            this.totalAlertsOfFraud() +
            this.totalAlertsOfQuality() +
            this.totalAlertsOfVLC() +
            this.totalAlertsOfRT());
    }
    reset() {
        this.alerts = [];
        this.smartphoto = JSON.parse(JSON.stringify(this.originalSmartphoto));
        this.addDamagesAlerts(this.smartphoto.damageSummary);
        this.addFraudsAlerts(this.smartphoto.fraudSummary, this.smartphoto.GPSPermissionsAccepted);
        this.addQualityAlerts(this.smartphoto.qualitySummary, this.smartphoto.notSupportWebGL);
        this.addRTAlert();
        this.update();
    }
    update(name, value = false) {
        const found = this.alerts.find((alert) => alert.name === name);
        if (found) {
            found.value = value;
        }
        this.damages = this.getActive(AlertCategory.Damages);
        this.frauds = this.getActive(AlertCategory.Frauds);
        this.quality = this.getActive(AlertCategory.Quality);
        this.vlc = this.getActive(AlertCategory.VLC);
        this.rt = this.getActive(AlertCategory.RT);
    }
    get(name) {
        const found = this.alerts.find((alert) => alert.name === name);
        return found?.value ?? false;
    }
    exportFraudSummary() {
        return this.smartphoto.fraudSummary;
    }
}
